import type { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'
import type { TFunction } from 'i18next'

import { appToaster } from '~/libs/toaster'
import { convertAreaLabel } from '~/models/area'

/** 発電所と系統コードのエリアが違うまま保存された時の注意 (backend の site_area_mismatch)。 */
export type SiteAreaMismatchNotice = {
  siteName: string
  siteAreaCode: AreaCode
  plantCode: string
  plantAreaCode: AreaCode
}

/** 保存は通っているので、止めずに toast で知らせる (登録ダイアログと詳細の保存で共通)。 */
export function showSiteAreaMismatchToast(
  t: TFunction,
  mismatch: SiteAreaMismatchNotice | undefined,
): void {
  if (mismatch === undefined) return
  appToaster.create({
    type: 'warning',
    closable: true,
    description: t('page:adminPlantUnitMaster.unit.siteAreaMismatch', {
      site: mismatch.siteName,
      siteArea: convertAreaLabel(mismatch.siteAreaCode),
      plantCode: mismatch.plantCode,
      plantArea: convertAreaLabel(mismatch.plantAreaCode),
    }),
  })
}
